export var SPACE_REPOSITORY = 'SPACE_REPOSITORY';